import SmartTipHA from './SmartTipHA';

export default SmartTipHA;
